import { render, staticRenderFns } from "./ResetPasswordV2.vue?vue&type=template&id=7f7aa27f&scoped=true&"
import script from "./ResetPasswordV2.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordV2.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordV2.vue?vue&type=style&index=0&id=7f7aa27f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7aa27f",
  null
  
)

export default component.exports